import { fetchApi} from "@/utils/axios";
import URL from "@/api/urlConfig"
// 获取分析报告列表
export function getReportList(data) {
   return fetchApi(URL.REPORT_LIST, data, "POST", "body");
}
